(function() {
    /* globals $, angular */
    'use strict';

    angular.module('dashboardApp').controller('startController', Controller);
    Controller.$inject = [
        'Login',
        'Routing',
        '$cookies',
        '$location',
    ];

    function Controller (
        Login,
        Routing,
        $cookies,
        $location
    ) {

        var vm = this;

        vm.showProgress = true;
        vm.showError = false;



        //----------- initialization ------------------

        function init() {
            //alert('start -> init');
            // TO BE REMOVED after decommissioning the old web servers
            // Some apps have a Home button, which redirects to /irp/
            // We want to redirect further to oAuthDispatcher, which will take care to redirect to old or new IRP
            var isRedirectedFromOldServer = $cookies.get('redirect-from');
            if(isRedirectedFromOldServer == "1")
            {
                // Clean the cookie
                $cookies.remove('redirect-from', { path: '/' });
                // Redirect to OAuthDispatcher
                Routing.oAuthDispatcher();
            }
            else
            {
                // check if there's an open session
                Login.check().then(function(success) {
                    if (success) {
                        Routing.apps();
                    } else {
                        Routing.login();
                    }

                });
            }
        }


        init();


    }



})();
